// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerCategoryDropdown.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Category Dropdown component
 */

import React, { Component, PropTypes } from "react";
import { action } from "mobx";
import { observer } from "mobx-react";
import constants from "logic/data/Izenda.ReportDesignerConstants";
import DropDown from "share/components/controls/Izenda.DropDown";
import Validator from "share/components/hoc/Izenda.Validator";
import { isEmpty, filter, map, includes, forEach } from "lodash/fp";

const DropDownValidator = Validator()(DropDown);

@observer
export default class ReportDesignerCategoryDropdown extends Component {
  static propTypes = {
    dataSourceItem: PropTypes.object.isRequired,
    categoryOptions: PropTypes.array.isRequired,
    fieldName: PropTypes.string.isRequired,
    dataSourceDetail: PropTypes.object
  }

  @action("onChangeDropdown")
  onChangeDropdown = ({ value, label }) => {
    const { dataSourceItem, fieldName, onChange, dataSourceDetail } = this.props;
    const categoryKey = constants.TABLE_DEF.ADVANCED_MODE.category.key;

    if (!dataSourceItem.isKeyJoin) {
      const categoryIds = this.getUpperCategoryIds(dataSourceItem);
      dataSourceItem.resetKeyJoinCategory(categoryIds);
    }

    fieldName === categoryKey
      ? dataSourceItem.setJoinDataSourceCategory(value, label)
      : dataSourceItem.setForeignDataSourceCategory(value, label);
    dataSourceDetail.markDataSourceGridDirty();
  }

  getUpperCategoryIds(currentRelationship) {
    const { dataSourceDetail } = this.props;
    const upperRelationships = !isEmpty(currentRelationship)
      ? filter(item => item.level <= currentRelationship.level, dataSourceDetail.dataSourceGrid)
      : [];
    let categoryIds = [];

    forEach(relationship => {
      const { joinDataSourceCategoryId, foreignDataSourceCategoryId } = relationship;
      const readyCategory = joinDataSourceCategoryId && !includes(joinDataSourceCategoryId, categoryIds);
      readyCategory && categoryIds.push(joinDataSourceCategoryId);

      const readyForeignCategory = foreignDataSourceCategoryId && !includes(foreignDataSourceCategoryId, categoryIds);
      readyForeignCategory && categoryIds.push(foreignDataSourceCategoryId);
    }, upperRelationships);

    return categoryIds;
  }

  render() {
    const { fieldName, dataSourceItem, categoryOptions } = this.props;

    return (
      <DropDownValidator
        options={categoryOptions}
        onChange={this.onChangeDropdown}
        value={dataSourceItem[fieldName]}
        validateAttribute={fieldName}
        valueField="value"
        labelField="label"
        blankOption
        hideIcon
        showTooltip
        validations={constants.REQUIRED_CONSTRAINT}
        field={fieldName}
        group={"Relationships" + dataSourceItem.tempId}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSource/Izenda.ReportDesignerCategoryDropdown.js